/**
 * StatusMessage.tsx — Status message display component
 *
 * Displays informational messages in a styled container with proper formatting
 * for multi-line text and word wrapping.
 */

import React from "react";
import { tokens } from "@fluentui/react-components";
import "./StatusMessage.css";

interface StatusMessageProps {
  message: string;
}

export const StatusMessage: React.FC<StatusMessageProps> = ({ message }) => {
  return (
    <div
      className="status-message-container"
      style={{
        padding: tokens.spacingVerticalS,
        backgroundColor: tokens.colorNeutralBackground2,
        borderRadius: tokens.borderRadiusMedium,
        fontSize: tokens.fontSizeBase200,
      }}
    >
      {message}
    </div>
  );
};
